export default __webpack_public_path__ + "static/space-station-76655e00f59940d8e09e3f090465b36f.png";